import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import { SuiviChefEntrepriseDetailPage, SuiviChefEntrepriseListPage } from ".";

export interface SuiviChefEntrepriseProps {}

export const SuiviChefEntreprise: React.FunctionComponent<SuiviChefEntrepriseProps> = props => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}`} exact>
        <SuiviChefEntrepriseListPage />
      </Route>
      <Route path={`${match.path}/:suiviId?`} component={SuiviChefEntrepriseDetailPage} exact />
    </Switch>
  );
};
